var paragraph_default = {
  "fontElementMap": "rT0qe",
  "elementSpacing": "XlQz-",
  "text": "DcJ9z XlQz-",
  "child": "_6HCTV"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
